/* eslint-disable jsx-a11y/anchor-is-valid */
import {DefaultTitle} from '../header/page-title/DefaultTitle'

const Toolbar = () => {
  return (
    <>
      <div className='w-full border-b bg-white' id='kt_toolbar'>
        {/* begin::Container */}
        <div id='kt_toolbar_container' className='flex justify-between items-center px-4 py-3 mt-[20px]'>
          <DefaultTitle />
        </div>
      </div>
    </>
  )
}

export {Toolbar}
